import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { transactionsRecurringList_template } from "../components/templates/transactionsRecurringList_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class transactions_recurring extends vnModule_knockoutJS{


    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionsRecurringList_template;
    protected pagination: pagination_template;
    protected validationsList: validationsList_template;

    protected getModuleName(){
        return "transactions_recurring";
    }

    buildContent() : Array<Element>{

        this.elementsList = new transactionsRecurringList_template("list", this.viewModel, this);

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getReferences();
    }

    protected editTransaction(data){
        this.saveViewModule(this.elementsList.getTemplateViewModel());
        page('/payment/transactions/recurring/edit/'+ data.id);
    }

    protected reverseTransaction(data){
        this.saveViewModule(this.elementsList.getTemplateViewModel());
        page('/payment/transactions/recurring/delete/'+ data.id);
    }

    protected addTransaction(){
        this.saveViewModule(this.elementsList.getTemplateViewModel());
        page('/payment/transactions/recurring/add');
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected transactionListReorder(){
        this.filterList();
    }

    protected filterSimpleOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    protected getReferences() {

        if( "getReferences" in this.XHRHdls ){
            this.XHRHdls["getReferences"].cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/payment/transactions/recurring/references/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdls["getReferences"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getReferences"].onReadyStateFunction = this.onGetRecurringTransactionReferencesRequestReturn;
        this.XHRHdls["getReferences"].execute();
    }

    protected onGetRecurringTransactionReferencesRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    // obj.listTemplate.validationsList.clearMessages();
                    obj.updateReferenceList(responseParsed);
                    obj.filterList()
                } else if (req.request.status == "423") {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    let url: string;
                    if (obj.getVnAppZone().app.params.idBrand) {
                        url = '/' + obj.getVnAppZone().app.params.idBrand + '/home';
                    } else {
                        url = '/';
                    }
                    page.redirect(url);
                } else {

                    obj.listTemplate.onUpdateError(req.request.status, responseParsed);
                }

            }
        }
    }

    protected updateReferenceList(response: any): void {

        this.elementsList.setValnetSupportSplitOptions(response.valnetSupportSplit);
        this.elementsList.setRoleFilterItems(response.roles);
        this.elementsList.setEntryTypeFilterItems(response.entryTypes);
        this.elementsList.setBrandFilterItems(response.brands);
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if('filterList' in this.XHRHdls ){

            this.XHRHdls["filterList"].cancelAndReset();
        }

        let usrReq_url: string = '/api/payment/transactions/recurring/list/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );

        this.XHRHdls["filterList"] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        let localCheck = this.XHRHdls["filterList"].requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdls["filterList"].requestId ){
                _myThis.XHRHdls["filterList"].onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdls["filterList"].execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                const{totalPages, total} = responseParsed.data;

                if(  req.request.status == 200  ){
                    const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100
                    obj.elementsList.validationsList.clearMessages();
                    obj.elementsList.setResultInfo(total, totalPages, execTime);
                    obj.updateList(data);

                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let usersToSet = [];
        for (let item of responseParsed.transactions) {
            usersToSet.push( {
                amount:  item.amount,
                note: item.note,
                user_fullName: item.user_fullName,
                creation_type : item.creation_type,
                action_type : item.action_type,
                action_type_id : item.action_type_id,
                entry_type : item.entry_type,
                id: item.id,
                type: item.type,
                currency: item.currency,
                dateCreation: item.dateCreation,
                emakiEdit: '/payment/transactions/recurring/edit/' + item.id
            } )
        }
        this.elementsList.setTransactions(usersToSet);
        this.viewModel.list.pagination.itemCount(responseParsed.total);
    }

    protected onUpdateError(requestStatus: any, responseParsed) : void{
        let msg = responseParsed.message;
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    protected deleteTransaction(id){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));
        this.saveViewModule(this.elementsList.getTemplateViewModel());
        //this.saveViewModule(this.elementsList.getViewModelForRequest());

        if('deleteTransaction' in this.XHRHdls ){

            this.XHRHdls["deleteTransaction"].cancelAndReset();
        }


        let _this = this;
        let formReq_url: string = '/api/payment/transaction/recurring/delete/';
        let formReq_params: Array<Array<string>> = [['data', ko.toJSON({ id: id })]];
        this.XHRHdls["deleteTransaction"] = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        this.XHRHdls["deleteTransaction"].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls["deleteTransaction"].onReadyStateFunction = function(req, obj) {
            return function() {
                if (req.request.readyState == 4) {

                    let responseParsed = JSON.parse(req.request.response);

                    if (req.request.status == 200) {

                        //obj.releaseLock();
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Transaction was deleted successfully !");
                        obj.elementsList.validationsList.clearMessages();

                        page.redirect('/payment/transactions/recurring/list');

                    } else if (responseParsed.type == 'error_validation') {

                        obj.elementsList.validationsList.setMessages(responseParsed.validations);
                        window.scrollTo(0, 0);

                    } else if (responseParsed.type == 'error') {

                        obj.elementsList.validationsList.setSingleMessage({field: "error", label: req.request.status, message: responseParsed.message});
                        window.scrollTo(0, 0);
                    }

                    // LOADING : ends
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                }
            }
        };

        this.XHRHdls['deleteTransaction'].execute();

    }

    protected filterDropdownOnChange(): void {

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }



    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }
}



// WEBPACK FOOTER //
// ./js/modules/transactions_recurring.ts